/** Scalar-only phone measurements: never images, landmarks or face dimensions. */
export interface MeasureSample {
  drawnFrames: number;
  visible: boolean;
  interruptions: number;
  losses: number;
  cameraFps: number | null;
  inferenceFps: number;
  physicalLenses: boolean;
  quality: string;
}
export class SessionMeasure {
  private previous: { time: number; sample: MeasureSample } | null = null;
  private initialInterruptions = 0;
  private start = 0;
  private duration = 0;
  private frames = 0;
  private elapsed = 0;
  private initialLosses = 0;
  interruptions = 0;
  active = false;
  result: { seconds: number; renderFps: number; interruptions: number; losses: number } | null = null;
  begin(now: number, seconds: number, sample: MeasureSample): void {
    this.start = now; this.duration = seconds * 1000;
    this.previous = { time: now, sample }; this.initialLosses = sample.losses;
    this.frames = 0; this.elapsed = 0; this.interruptions = 0;
    this.initialInterruptions = sample.interruptions;
    this.result = null; this.active = true;
  }
  cancel(): void { this.active = false; this.previous = null; }
  remaining(now: number): number { return Math.max(0, Math.ceil((this.duration - (now - this.start)) / 1000)); }
  sample(now: number, sample: MeasureSample): number | null {
    const previous = this.previous;
    const dt = previous ? now - previous.time : 0;
    const count = previous ? sample.drawnFrames - previous.sample.drawnFrames : 0;
    const fps = dt > 0 && count >= 0 ? count * 1000 / dt : null;
    if (this.active && previous) {
      if (count < 0 || sample.physicalLenses !== previous.sample.physicalLenses) { this.cancel(); return fps; }
      this.frames += count; this.elapsed += dt;
      this.interruptions = Math.max(0, sample.interruptions - this.initialInterruptions);
      if (now - this.start >= this.duration) {
        this.result = { seconds: this.elapsed / 1000, renderFps: this.elapsed ? this.frames * 1000 / this.elapsed : 0,
          interruptions: this.interruptions, losses: Math.max(0, sample.losses - this.initialLosses) };
        this.active = false;
      }
    }
    this.previous = { time: now, sample };
    return fps;
  }
}
